import { Box, Button, Tooltip, tooltipClasses } from "@mui/material";
import { styled } from "@mui/material/styles";
import RefreshIcon from "@mui/icons-material/Refresh";

const CustomTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(() => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: "#4a4949",
        color: "#fff",
        fontSize: "13px",
        padding: "3px 10px",
        borderRadius: "16px",
        boxShadow: "0px 4px 12px rgba(0,0,0,0.3)",
    },
    [`& .${tooltipClasses.arrow}`]: {
        color: "#4a4949",
    },
}));

const RefreshButton = ({ headerHeight }) => {
    return (
        <Box
            sx={{
                position: "fixed",
                top: headerHeight + 20,
                right: 30,
                zIndex: 9999,
                borderRadius: '10px'
            }}
        >
            <CustomTooltip title="Click to Refresh" arrow placement="left">
                <Button
                    onClick={() => window.location.reload()}
                    sx={{
                        backgroundColor: "#000",
                        borderRadius: '10px',
                        color: "#fff",
                        minWidth: "15px",
                        height: 22,
                        textTransform: "none",
                        "&:hover": {
                            backgroundColor: "#4a4949",
                        },
                    }}
                >
                    <RefreshIcon fontSize="small" sx={{ padding: 0 }} />
                </Button>
            </CustomTooltip>
        </Box>
    )
}

export default RefreshButton;